import { Grid, Card, StatsCard } from "../index";
import { Button } from "../index";
import Chart from "react-apexcharts";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { QRCodeCanvas } from "qrcode.react";
import { fetchMerchantPin } from "../../redux/actions/merchant.actions";

function MerchantDashboard({ operational, revenue }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.auth?.userInfo);
  const [pin, setPin] = useState(null);

  // The redemption PIN is what a customer's app scans or types at the counter,
  // so the merchant needs to be able to see their own. It is not present on any
  // merchant read payload -- only this endpoint returns it, and only to them.
  useEffect(() => {
    if (!userInfo?.id) return;
    dispatch(fetchMerchantPin(userInfo.id)).then(setPin);
  }, [dispatch, userInfo?.id]);

  const overviewChartOptions = {
    colors: ["#5C656E", "#C7FF00", "#2C343B"],
    legend: {
      position: "bottom",
      horizontalAlign: "left",
    },
    chart: {
      type: "donut",
    },
    labels: ["Total", "Active", "Pending Approval"],
    dataLabels: {
      enabled: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  };

  const overviewChartData = [
    operational?.total_vouchers || 0,
    operational?.active_vouchers || 0,
    operational?.vouchers_pending_approval || 0,
  ];

  return (
    <Grid columns={2}>
      <div className="height_full">
        <Card title="Your redemption code" className="height_full">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 20,
              padding: "8px 4px",
            }}
          >
            {pin ? (
              <>
                <QRCodeCanvas value={pin} size={116} includeMargin />
                <div>
                  <h5 style={{ margin: 0, opacity: 0.6 }}>MERCHANT PIN</h5>
                  <h2 style={{ margin: "4px 0 8px", letterSpacing: 2 }}>{pin}</h2>
                  <h5 style={{ margin: 0, opacity: 0.6, fontWeight: 400 }}>
                    Show this code at the counter. Customers scan it in the app,
                    or you can enter the PIN yourself, to redeem a voucher.
                  </h5>
                </div>
              </>
            ) : (
              <h5 style={{ margin: 0, opacity: 0.6, fontWeight: 400 }}>
                Your redemption code is not available for this account.
              </h5>
            )}
          </div>
        </Card>
        <StatsCard
          className="mt20"
          title="Total Redemptions"
          value={operational?.total_redemptions}
          decimals={0}
          hasDetails={false}
        ></StatsCard>
        <Card title="Vouchers" className="mt20 height_full">
          <div
            className="height_full"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Chart
              options={overviewChartOptions}
              series={overviewChartData}
              height={370}
              width="100%"
              type="donut"
            />
          </div>
        </Card>
      </div>

      <div className="height_full">
        <Card
          title="Most Redeemed Vouchers"
          footerContent={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                variant="tertiary"
                handleClick={() => history.push("/vouchers")}
              >
                View All
              </Button>
            </div>
          }
        >
          <div className="pt-[20px] height_full">
            {!revenue?.most_active_vouchers?.length ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  alignContent: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  color: "var(--felix-text-muted)",
                  marginTop: "30px",
                  marginBottom: "30px",
                }}
              >
                <h3>No Vouchers Redeemed Yet</h3>
              </div>
            ) : (
              revenue?.most_active_vouchers?.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingBottom: "15px",
                    marginBottom:
                      index + 1 === revenue?.most_active_vouchers?.length
                        ? ""
                        : "30px",
                    borderBottom:
                      index + 1 !== revenue?.most_active_vouchers?.length
                        ? "1px solid var(--felix-border)"
                        : "",
                  }}
                >
                  <h5>{item.name}</h5>
                  <h5>{item.count}</h5>
                </div>
              ))
            )}
          </div>
        </Card>
        <Card
          title="Latest Redemptions"
          className="mt20"
          footerContent={
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                variant="tertiary"
                handleClick={() => history.push("/voucher-redemption")}
              >
                View All
              </Button>
            </div>
          }
        >
          <div className="pt-[20px] height_full">
            {!revenue?.latest_redemptions?.length ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  alignContent: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  color: "var(--felix-text-muted)",
                  marginTop: "30px",
                  marginBottom: "30px",
                }}
              >
                <h3>No Redemptions Yet</h3>
              </div>
            ) : (
              revenue?.latest_redemptions?.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingBottom: "15px",
                    marginBottom:
                      index + 1 === revenue?.latest_redemptions?.length
                        ? ""
                        : "30px",
                    borderBottom:
                      index + 1 !== revenue?.latest_redemptions?.length
                        ? "1px solid var(--felix-border)"
                        : "",
                  }}
                >
                  <h5>{item.name}</h5>
                  <h5>{item.count}</h5>
                </div>
              ))
            )}
          </div>
        </Card>
      </div>
    </Grid>
  );
}

export default MerchantDashboard;
